// extracted by mini-css-extract-plugin
export default {"todos":"todos_todos__DXkdD"};